<template>
  <div>
    <nav-bread>
      <span slot="company" style="margin-right:15px">{{providerList.providerName}}</span>
      <span slot="com_allgoods">全部商品</span>
    </nav-bread>
    <div class="binBan">
      <img class="banPic" src="../../assets/shoppic.jpg" alt=""/>
      <p class="conName">{{providerList.providerName}}</p>
      <div class="banBtn">
        <ul>
          <li @click="toHome">
            <slot name="index">首页</slot>
          </li>
          <li @click="toAllGoods" class="mineCol">
            <slot name="allGoods">全部商品</slot>
          </li>
          <!--<li v-bind:class="{'mineCol':!allGoodFlag}" @click="toAllGoods">全部商品</li>-->
        </ul>
      </div>
    </div>

    <!--产品列表-->
    <!-- search result accessories list -->
    <div class="comMain">
      <div class="accessory-list-wrap">
        <div class="accessory-list col-5">
          <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30">
            <li v-for="(item,index) in  goodsList" @click="todetection(item.id,item.remark)">
              <div class="pic">
                <a href="javascript:;"><img :src="item.img" alt=""></a>
              </div>
              <div class="main">
                <div class="name">{{item.itemName}}</div>
                <div class="price">￥{{item.price}}</div>

                <div class="area">{{item.providerArea}} | {{item.providerName}}</div>
<!--                <div class="area">月销{{item.sales}}件</div>-->
                <!--<div class="btn-area">-->
                <!--<a href="javascript:;" class="btn btn&#45;&#45;m" @click="addCart(item.productId)">加入购物车</a>-->
                <!--</div>-->
              </div>
            </li>
          </ul>

          <div class="f_tip" v-if="goodsList.length == 0" style="margin-top:150px;font-size: 14px;">搜索完成，没有结果</div>
          <div class="f_tip" v-else-if="!hasMoreData">---已经到底啦---</div>
          <!--&lt;!&ndash;加上滚动加载的div&ndash;&gt;-->
          <!--<div class="load-more" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30">-->
          <!--&lt;!&ndash;加载中...&ndash;&gt;-->
          <!--<img src="./../assets/loading-spinning-bubbles.svg" v-show="hasMoreData">-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import '../../assets/css/base.css'
  import '@/assets/css/product.css'
  import {getCookie} from "../../util/util";

  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'

  export default {
    name: "com-all-goods",
    data() {
      return {
        id: this.$route.query.id,
        providerList: [],
        goodsList: [],
        page: 1,
        limit: 10,
        hasMoreData: true,
        loading:false,
      }
    },
    components: {
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
    },
    methods: {
      //获取店铺相关信息
      getComInfo() {
        console.info(this.id)
        axios.get("/jys/provider/" + this.id).then((res) => {
          this.providerList = res.data.info;
          console.info(this.providerList)
        })
      },
      //鼠标滚动时需要加载的方法
      loadMore() {
        console.log("LoadMore")
        // this.page ++
        this.getShopItems()
      },

      //显示商品列表
      getShopItems() {
        this.loading = true
        axios.get("/jys/provider/" + this.id + '/item', {
          params: {
            page: this.page,
            limit: this.limit
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token") ? getCookie("_token") : ""
          }
        }).then((res) => {
          var goodsListTem = this.goodsList
          console.info(res.data.code)
          if (res.data.code == 0) {
            if (this.page == 1) {
              goodsListTem = []
            }

            //新版
            var goodsList = res.data.page.list

            if (goodsList.length < this.limit) {
              this.goodsList = goodsListTem.concat(goodsList)
              this.loading = true
              this.hasMoreData = false
            } else {
              this.goodsList = goodsListTem.concat(goodsList)
              this.loading = false
              this.hasMoreData = true
              this.page = this.page + 1
            }
          }
        })
      },

      //        跳转到产品详情页
      todetection(id, remark) {
        this.$router.push({path: "/detection", query: {id: id, remark: remark}})
      },
//        跳转到首页
      toHome() {
        this.$router.push({path: "/company/index", query: {id: this.id}})
      },

      toAllGoods() {
        this.$router.push({path: "/company/all", query: {id: this.id}})
      },

    },
    mounted: function () {
      this.getShopItems()
      this.getComInfo()
    }


  }
</script>

<style scoped>
  body {
    font-size: 0;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .conBan {
    width: 66.66%;
    margin: 0 auto;
    background: #00C5B0;
    font-size: 0;
  }

  .banPic {
    width: 100%;
    height: 500px;
  }

  .binBan {
    position: relative;
  }

  .conName {
    position: absolute;
    top: 206px;
    right: 426px;
    font-size: 39px;
    font-weight: bold;
  }

  .banBtn {
    width: 66.66%;
    background: #000;
    height: 40px;
    position: absolute;
    bottom: 0;
    left: 17%;
  }

  .banBtn ul li {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 80px;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }

  .banBtn ul li:hover {
    color: #03DAC4;
  }

  .comCon {
    width: 76%;
    margin-top: 50px;
  }

  .comCon p {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .comCon div {
    font-size: 14px;
    text-indent: 2em;
  }

  .comLogo {
    margin-top: 50px;
    width: 150px;
    height: 150px;
    border-radius: 150px;
  }

  .comMain {
    width: 66.66%;
    margin: 0 auto;
    margin-top: 50px;
  }

  .name {
    font-size: 16px;
  }

  .accessory-list .main .price {
    font-size: 16px;
  }

  .mineCol {
    color: #00C5B0 !important;
  }

  .f_tip {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/ComAllGoods.vue